import { Component, OnInit } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl, ValidationErrors, FormArray } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Message } from 'primeng/primeng';

import { DashboardSorttimeService } from '../../service/dashboard-sorttime/dashboard-sorttime.service';
import { DashboardUrlService } from '../../service/dashboard-url/dashboard-url.service';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  public dashboard: number = null;
  public dashboard_url: SafeResourceUrl = null;
  public dashboard_name: string = null;
  public msgs: Message[] = [];
  public loading: boolean = true;

  public userId: number = null;
  public roleId: number = null;

  public companyRoles = [59, 62, 73];
  public companyDaviviendaRole = [76, 81];

  public documental = [7, 8, 54];
  public hire = [9, 10];
  public selection = [4, 5, 6, 35, 38, 67];
  public senior_position = [20, 33, 37, 43, 44, 56, 60, 66, 70, 72, 74, 78];
  public systems_ti = [47, 76, 77];
  public communications = [73, 75];
  public admin = [58, 62, 63, 64, 65];
  public company = [31];

  public company_report_form: FormGroup;
  public typeReportOptions: any[] = [];
  public showCompanyMenu: boolean = false;
  public companySorttime: any;
  public companyOptions: any[] = [];

  constructor(
    public dashboardUrlService: DashboardUrlService,
    public dashboardSorttimeService: DashboardSorttimeService,
    private sanitizer: DomSanitizer,
    public fb: FormBuilder,
  ) {
    this.roleId = JSON.parse(localStorage.getItem('profile')).roles[0].id;
    this.userId = JSON.parse(localStorage.getItem('profile')).roles[0].pivot.user_id;

    this.typeReportOptions = [
      {label: 'Informe de rotación', value: 901},
      {label: 'Informe de acumulados', value: 902},
      {label: 'Informe de incapacidades', value: 903},
    ];
  }

  ngOnInit() {
    if (this.companyRoles.includes(this.roleId))
      this.getCompanySorttimeIdFromUserId(this.userId, this.typeReportOptions[0].value);   // Por defecto que sea Informe de rotación
    else if (this.companyDaviviendaRole.includes(this.roleId)) {
      this.dashboard = 2;   // Corresponde a informe de servicio al cliente en DB tabla dashboards
      this.getDashboardUrl(this.dashboard);
    } else
      this.getDashboardId();

    this.createCompanyReportsForm();
  }

  createCompanyReportsForm(data:any = null){
    data = data || {
      type_report: this.typeReportOptions[0].value,   // Por defecto que sea Informe de rotación
      company: ''
    }
   
    this.company_report_form = this.fb.group({
      type_report: [ data.type_report ],
      company: [ data.company ],
    });
  }

  public getDashboardId() {
    var employeePositionId = JSON.parse(localStorage.getItem('profile')).employee.employee_position_id;
    if(this.documental.includes(employeePositionId))
      this.dashboard = 2;   // Corresponde a informe de servicio al cliente en DB tabla dashboards
    else if(this.hire.includes(employeePositionId))
      this.dashboard = 2;   // Corresponde a informe de servicio al cliente en DB tabla dashboards
    else if(this.selection.includes(employeePositionId))
      this.dashboard = 1;   // Corresponde a informe general en DB tabla dashboards
    else if(this.senior_position.includes(employeePositionId))
      this.dashboard = 1;   // Corresponde a informe general en DB tabla dashboards
    else if(this.systems_ti.includes(employeePositionId))
      this.dashboard = 2;   // Corresponde a informe de servicio al cliente en DB tabla dashboards
    else if(this.communications.includes(employeePositionId))
      this.dashboard = 2;   // Corresponde a informe de servicio al cliente en DB tabla dashboards
    else if(this.admin.includes(employeePositionId))
      this.dashboard = 1;   // Corresponde a informe general en DB tabla dashboards
    /* else if(this.company.includes(employeePositionId)) 
      this.dashboard = 0; */   // Corresponde a diagrama de tortas dashboards
    else
      this.dashboard = 2;   // Corresponde a informe de servicio al cliente en DB tabla dashboards

    if (this.dashboard != 0)
      this.getDashboardUrl(this.dashboard);
  }

  public getDashboardUrl(report_id) {
    this.dashboardUrlService.getOneDashboardURL(report_id).toPromise().then(
      response => {
        this.dashboard_url = this.sanitizer.bypassSecurityTrustResourceUrl(response.json().data[0].url);
        this.dashboard_name = response.json().data[0].name;
        this.showCompanyMenu = false;    // Para que oculte el menú de companía
        this.loading = false;
      },
      error => {
        this.msgs = [];
        this.msgs.push( { severity: 'error', summary: 'error' } );
        this.loading = false;
      }
    );
  }

  public getCompanySorttimeIdFromUserId(user_id, reportType) {
    this.dashboardSorttimeService.getCompaniesFromUserId(user_id).toPromise().then(
      response => {
        var dashboard_request = response.json();

        if (dashboard_request.length > 0) {
          for (var i = 0; i < dashboard_request.length; i++)
            this.companyOptions.push( { name: dashboard_request[i].name, id_sorttime: dashboard_request[i].id_sorttime } );

          if (this.companyOptions.length > 0)
            this.defaultCompanyReport(reportType);
          else
            this.dashboard = 0;

        } else
          this.dashboard = 0;
        
        this.loading = false;
      },
      error => {
        this.msgs = [];
        this.msgs.push( { severity: 'error', summary: 'error' } );
        this.loading = false;
      }
    );
  }

  changeCompanyReport(event) {
    const reportType = event.value;
    this.dashboard_url = this.sanitizer.bypassSecurityTrustResourceUrl(this.getSorttimeReport(reportType, this.companySorttime.id_sorttime));
  }

  changeCompany(event) {
    // this.companySorttime = event.target.value;
    this.companySorttime = this.company_report_form.get('company').value;

    this.company_report_form.get('type_report').setValue(this.typeReportOptions[0].value);

    this.dashboard_url = this.sanitizer.bypassSecurityTrustResourceUrl(this.getSorttimeReport(this.typeReportOptions[0].value, this.companySorttime.id_sorttime));
    this.dashboard_name = this.companySorttime.name;
  }

  public defaultCompanyReport(reportType) {
    this.companySorttime = this.companyOptions[0];

    this.company_report_form.get('company').setValue(this.companySorttime);

    this.dashboard_name = this.companySorttime.name;
    this.dashboard_url = this.sanitizer.bypassSecurityTrustResourceUrl(this.getSorttimeReport(reportType, this.companySorttime.id_sorttime));
    this.dashboard = reportType;    // Se le asigna el valor del reportType ya que es diferente de 0, para que se pueda mostrar en el html
    this.showCompanyMenu = true;    // Para que muestre el menú de compañía
  }

  public getSorttimeReport(reportType, idSorttimeCompany) {
    var url = 'https://sorttime.co/SorttimeBIClientes/Home/EmbedReport?empresa=RHS&';
    var token = 'RVrjvlGkf5aPozVAg145';

    url += 'idBI=' + reportType + '&idCliente=' + idSorttimeCompany + '&token=' + token;

    return url;
  }

  public hasRole(rol) {
    var r: boolean = false;
    
    if(this.roleId == rol)
      r = true;
    
    return (r);
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/dashboard/dashboard.component.ts